var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 17C0.5 7.62629 8.12589 0 17.5 0C26.8741 0 34.5 7.62629 34.5 17C34.5 26.3737 26.8741 34 17.5 34C8.12589 34 0.5 26.3737 0.5 17ZM17.5895 23.0025L25.4846 15.1075C26.3508 14.2416 26.3508 12.8377 25.4846 11.9718C24.6184 11.1056 23.2153 11.1056 22.3491 11.9718L16.0217 18.2988L13.0205 15.2979C12.1543 14.4317 10.7511 14.4317 9.88493 15.2979C9.01873 16.1638 9.01873 17.5677 9.88493 18.4335L14.4539 23.0025C15.3201 23.8687 16.7234 23.8687 17.5895 23.0025Z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.dfcae1991620227da30d29469ab7006e.svg";
export { ForwardRef as ReactComponent };